
import request from '@/utils/request'


export function getPageList(data) {
  return request({
    url: 'food/getPageList',
    method: 'post',
    data
  })
}

export function save(data) {
  return request({
    url: 'food/save',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: 'food/delete',
    method: 'post',
    data
  })
}
